import { render, staticRenderFns } from "./LogoImg.vue?vue&type=template&id=3e625265&scoped=true"
import script from "./LogoImg.vue?vue&type=script&lang=js"
export * from "./LogoImg.vue?vue&type=script&lang=js"
import style0 from "./LogoImg.vue?vue&type=style&index=0&id=3e625265&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e625265",
  null
  
)

export default component.exports